export const trainingTourSteps = [
  {
    route: "/profile",
    title: "Profil ve API Ayarları",
    icon: "🔐",
    description:
      "Profil ekranı; kullanıcı bilgileri, şifre değişimi, pazaryeri/e-ticaret API hesapları ve fatura entegratörü ayarlarının yönetildiği kritik ekrandır.",
    highlights: [
      "Pazaryeri sekmesinde Trendyol/Hepsiburada gibi platformların API bilgilerini girip kaydet.",
      "E-ticaret sekmesinde (ör. İkas) bağlantı anahtarlarını doğrulayarak entegrasyonu aktif et.",
      "Fatura sekmesinde entegratör hesap bilgilerini güncel tut; faturalama akışı bu bilgilere bağlıdır.",
    ],
  },
  {
    route: "/XmlProductSource",
    title: "XML Kaynakları",
    icon: "🌐",
    description:
      "XML Kaynakları ekranı, tedarikçiden alınan XML verisini sisteme tanımlayıp ürünleri içeri aktarmak için kullanılır.",
    highlights: [
      "Tedarikçi XML URL ve erişim bilgilerini girerek kaynağı sisteme bağlayabilirsin.",
      "Tüm ürünler içeri aktarılmadıysa durum kayıtlarını kontrol ederek hatanın nedenini görebilirsin.",
      "Kaynağın hangi aralıklarla güncelleme aldığını bu ekrandan takip edebilirsin.",
      "Eğer tedarikçi sistemde yoksa önce `Taleplerim` üzerinden tedarikçi tanımı için talep oluşturmalısın.",
    ],
  },
  {
    route: "/PlaceProducts",
    title: "Pazaryeri Ürünleri",
    icon: "🏬",
    description:
      "Pazaryeri Ürünleri ekranı; Trendyol başta olmak üzere tüm pazaryerlerindeki ürünlerini sisteme çektiğin, mevcut ürünlerinle eşleştirdiğin ve çoklu kanal yönetimi yaptığın alandır.",
    highlights: [
      "Trendyol veya diğer pazaryerlerindeki ürünlerini sisteme çekerek merkezi ürün yönetimi oluştur.",
      "Pazaryerinden gelen ürünleri sistemdeki ürünlerinle eşleştir; bu yapı tüm pazaryerleri için geçerlidir.",
      "Eşleşen ürünleri diğer pazaryerlerine göndererek tek ürün havuzundan çoklu pazaryeri yayını yap.",
    ],
  },
  {
    route: "/categorys",
    title: "Kategoriler",
    icon: "🗂️",
    description:
      "Kategoriler ekranı, ürün gönderiminde kullanılacak kategori eşleşmelerini yönettiğin ana alandır.",
    highlights: [
      "Ürün gönderirken kategori eşleşmesi doğru olmalı; kategori özellikleri girilmeden ürünler gönderilmez.",
      "Kategori özelliklerinin farklılaşmasının ana nedeni kategori eşleştirmesidir, eşleşme değişirse istenen alanlar da değişebilir.",
      "Pazaryeri hata mesajı veriyorsa çoğunlukla kategoriye bağlı özelliklerin hatalı/eksik eşleşmesinden kaynaklanır.",
    ],
  },
  {
    route: "/sellerbrand",
    title: "Markalar",
    icon: "🏷️",
    description:
      "Markalar ekranı, sistemdeki markalarını yönetip pazaryeri markalarıyla eşleştirdiğin bölümdür.",
    highlights: [
      "Pazaryeri Converter içindeki markanı pazaryeri markası ile `Eşitle` butonundan eşleştir.",
      "Doğru eşleşme sayesinde ürün gönderiminde marka bilgisi pazaryerine doğru aktarılır.",
      "Pazaryerinde marka bulunamazsa gönderim sırasında marka seçimi/manüel eşleme gerekebilir.",
    ],
  },
  {
    route: "/orders",
    title: "Sipariş Listesi",
    icon: "🧾",
    description:
      "Sipariş Listesi ekranında tüm pazaryeri ve e-ticaret siparişlerini görüntüler, sipariş detaylarını incelersin.",
    highlights: [
      "Bu ekranda siparişler ve sipariş detayları görüntülenir; sipariş üzerinde doğrudan değişiklik yapılamaz.",
      "E-fatura entegrasyonu aktifse sipariş üzerinden fatura taslağı oluşturabilirsin.",
      "Sipariş detayında müşteri, ürün ve tutar bilgilerini kontrol ederek faturalama adımına geçebilirsin.",
    ],
  },
  {
    route: "/invoices",
    title: "Fatura Listesi",
    icon: "🧮",
    description:
      "Fatura Listesi, siparişlerden oluşan faturaların durumunu izlediğin ve kontrol ettiğin ekrandır.",
    highlights: [
      "Kesildi, bekliyor, hata aldı gibi fatura statülerini tek listede takip et.",
      "Hatalı faturaları tespit edip müşteri veya entegratör bilgisini kontrol et.",
      "Sipariş-fatura eşleşmesini doğrulayarak muhasebe akışını düzenli tut.",
    ],
  },
  {
    route: "/add-product",
    title: "Ürün Ekleme",
    icon: "➕",
    description:
      "Ürün Ekleme ekranı, pazaryerlerinden/XML'den ürün çekilmeyecekse veya Excel ile toplu ürün girişi yapılmayacaksa manuel ürün kartı oluşturmak için kullanılır.",
    highlights: [
      "Ürün kartındaki tüm alanlar değerlidir; pazaryerlerine gönderim için özellikle barkod ve fiyat bilgilerini eksiksiz gir.",
      "Kategori, marka ve zorunlu alanlar eksik/yanlışsa gönderim aşamasında ürün hata alabilir.",
      "Varyantların her biri ürün listesinde ayrı ürün gibi görünse de gönderim aşamasında birlikte gönderilebilir.",
    ],
  },
  {
    route: "/products",
    title: "Ürün Listesi",
    icon: "📦",
    description:
      "Ürün Listesi ekranı, mevcut ürün kartlarını filtreleyip düzenlediğin ana ürün yönetim alanıdır.",
    highlights: [
      "Filtre ve arama ile ürünleri hızlı bul, toplu işlem öncesi kapsamı netleştir.",
      "Ürün detayına girip fiyat, stok, görsel ve açıklama güncellemelerini yap.",
      "Gönderim hatası alan ürünler için önce bu ekranda veri eksiklerini tamamla.",
    ],
  },
  {
    route: "/price-rules",
    title: "Fiyat Kuralları",
    icon: "💸",
    description:
      "Fiyat Kuralları ekranı, ürün fiyatını kategori ve pazaryeri bazında otomatik hesaplatıp gönderim fiyatını belirlemek için kullanılır.",
    highlights: [
      "Örn: maliyet/fiyat 650 ₺ olan ürüne kategori bazlı kural verip ilgili pazaryerine %10 kâr hedefiyle yeni satış fiyatı üretebilirsin.",
      "Bu kurallar özellikle yeni ürün gönderiminde ve stok/fiyat güncelleme akışında devreye girer.",
      "Ürün daha önce gönderildiyse ve sonradan fiyat kuralı atandıysa, ilgili kategoriyi seçip `Toplu Fiyat Güncelle` adımında 0 TL artırım talebi oluşturarak kuralı tetikleyebilirsin.",
    ],
  },
  {
    route: "/categoryVariant",
    title: "Varyant Eşleştirme",
    icon: "🧩",
    description:
      "Bu ekranın amacı, ürün bilgisini değiştirmek değil; farklı pazaryerlerinin farklı isimlendirdiği özellikleri birbirine bağlamaktır.",
    highlights: [
      "Örnek mantık: bir pazaryerinde özellik adı `Beden`, diğerinde `Numara` olabilir. Burada bu iki alanın aynı anlama geldiğini tanımlarsın.",
      "Eşleşmeler kategori bazında çalışır; her kategori için pazaryerinin beklediği zorunlu özellik seti farklı olabilir.",
      "Toplu ürün gönderimi sırasında sistem bu eşleşmeleri kullanır; eşleşme eksikse ürün gönderimi durur veya pazaryeri hatası döner.",
      "Özellikle ayakkabı, giyim gibi varyantlı ürünlerde gönderimden önce ilgili kategori için eşleşmeleri kontrol etmek gerekir.",
    ],
  },
  {
    route: "/batch-processes",
    title: "Toplu Fiyat Güncelleme",
    icon: "⚙️",
    description:
      "Toplu Fiyat Güncelleme ekranı, çok sayıda ürünün fiyatını tek işlemde değiştirmek için kullanılır.",
    highlights: [
      "Kategori, marka veya filtreye göre ürün seti belirleyip toplu fiyat uygula.",
      "Yanlış ürünleri güncellememek için işlem öncesi kapsamı mutlaka kontrol et.",
      "Güncelleme sonrası ürün/pazaryeri yansımasını ilgili listelerden doğrula.",
    ],
  },
  {
    route: "/batch-text-processes",
    title: "Toplu Başlık ve Açıklama",
    icon: "✍️",
    description:
      "Toplu Başlık ve Açıklama ekranı, ürün metinlerini toplu düzenlemek için kullanılır.",
    highlights: [
      "Seçili ürünlerde başlık ve açıklama metinlerini tek işlemle güncelle.",
      "Pazaryeri kurallarına aykırı ifadeleri toplu temizleyebilirsin.",
      "Metin güncellemesi sonrası ürün yayındaki görünümü kontrol et.",
    ],
  },
  {
    route: "/sendProductBulk",
    title: "Toplu Ürün Gönderimi",
    icon: "🚀",
    description:
      "Toplu Ürün Gönderimi, ürünleri seçip pazaryerine adım adım gönderdiğin ana aktarım ekranıdır.",
    highlights: [
      "Adım 1'de pazaryeri ve kategori seç, adım 2'de gönderilecek ürünleri belirle.",
      "Adım 3'te pazaryeri kategori özelliklerini doldur; eksik özellik varsa ürün reddedilebilir.",
      "Son adımda gönderimi başlatıp sonucu `Ürün Transfer Durumu` ekranından takip et.",
    ],
  },
  {
    route: "/excelproduct",
    title: "Excel İşlemleri",
    icon: "📗",
    description:
      "Excel İşlemleri ekranı, ürün verilerini dosya üzerinden toplu içe/dışa aktarmak için kullanılır.",
    highlights: [
      "Sistem şablonuna uygun dosya ile toplu ürün girişi veya güncelleme yap.",
      "Kolon eşleşmeleri yanlışsa veri hatalı işlenebilir; yüklemeden önce kontrol et.",
      "Hatalı satırları düzeltip yeniden içe aktararak veri bütünlüğünü koru.",
    ],
  },
  {
    route: "/questions",
    title: "Mesajlar",
    icon: "💬",
    description:
      "Mesajlar ekranı, destek ekibiyle yapılan yazışmaları ve soru cevap sürecini takip ettiğin alandır.",
    highlights: [
      "Açık mesajları önceliğe göre sırala ve cevap süresini kısalt.",
      "Teknik sorunlarda ekran görüntüsü ve net hata bilgisi ile geri dönüş yap.",
      "Tekrarlanan sorular için standart cevap süreci oluştur.",
    ],
  },
  {
    route: "/user-tasks",
    title: "Taleplerim",
    icon: "🛠️",
    description:
      "Taleplerim ekranı, kullanıcı hata aldığında, bir adımda takıldığında veya farklı bir desteğe ihtiyaç duyduğunda talep oluşturduğu alandır.",
    highlights: [
      "Yaşadığın sorunu buradan yeni talep açarak destek ekibine iletebilirsin.",
      "Talep açıklamasına net problem tanımı yazmak çözüm süresini kısaltır.",
      "Açtığın taleplerin durumunu (açık, işlemde, kapalı) bu ekrandan takip edebilirsin.",
    ],
  },
  {
    route: "/Stock",
    title: "Stok Takibi",
    icon: "📉",
    description:
      "Stok Takibi ekranı, bir pazaryerinden gelen siparişin diğer pazaryerlerinde de stoku düşmesini sağlayan senkron yapıyı yönetmek için kullanılır.",
    highlights: [
      "Doğru stok senkronu için ürünlerin pazaryerleri arasında eşleşmiş olması gerekir.",
      "Ürün eşleştirmelerini `Pazaryeri Ürünleri` sayfasından kontrol edebilir, otomatik eşleşmeyenleri manuel eşleyebilirsin.",
      "Eşleşme eksikse sipariş gelse bile diğer kanallarda stok düşümü doğru çalışmayabilir.",
    ],
  },
  {
    route: "/product-sync",
    title: "Yayılım",
    icon: "🚀",
    description:
      "Yayılım ekranı, bir kaynak pazaryerindeki fiyat ve stok değişikliklerini, tanımladığın kurallara göre otomatik olarak diğer pazaryerlerine aktaran zaman tetiklemeli (periyodik) bir dağıtım sistemidir.",
    highlights: [
      "Sipariş beklemez; kaynak platformdaki fiyat/stok değişikliğini yaklaşık her 10 dakikada bir kontrol edip hedef pazaryerlerine yansıtır.",
      "Her hedef pazaryeri için ayrı bir fiyat kuralı (yüzde veya sabit tutar, ekleme ya da çıkarma) tanımlaman gerekir.",
      "Sipariş bazlı çalışan `Stok Takibi` özelliğinden farklıdır; ikisi birbirinden bağımsızdır ve aynı anda kullanılabilir.",
    ],
  },
  {
    route: "/Application",
    title: "Mağaza / Entegrasyonlar",
    icon: "🏪",
    description:
      "Mağaza / Entegrasyonlar ekranı, pazaryeri ve e-ticaret hesap bağlantılarını yönettiğin kurulum merkezidir.",
    highlights: [
      "Hangi özelliklerin ve hangi pazaryerlerinin açık/aktif olduğunu bu ekrandan görebilirsin.",
      "Yeni bir pazaryeri demosu veya yeni bağlantı kaydı oluşturma işlemi buradan yapılır.",
      "Yeni eklenen pazaryeri listede görünmüyorsa çıkış yapıp tekrar giriş yaparak oturumu yenilemelisin.",
    ],
  },
  {
    route: "/ProductTransfers",
    title: "Ürün Transfer Durumu",
    icon: "📨",
    description:
      "Ürün Transfer Durumu ekranı, gönderim sonrası ürün bazlı başarı/hata sonuçlarını takip ettiğin kontrol ekranıdır.",
    highlights: [
      "Gönderilen ürünlerin başarılı, bekleyen veya hatalı durumlarını satır bazında izle.",
      "Hata alan ürünlerde mesajı okuyup marka/kategori/varyant veya zorunlu alanları düzelt.",
      "Düzeltme sonrası aynı ürünleri yeniden toplu göndererek akışı tamamla.",
    ],
  },
];
